import type { GeoRule } from '@ps/web-martech-cms-types';
import { every } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

const useGeoVisibility = (rules: GeoRule[]) => {
  const country = useSelector(select.country.getCountry);

  return useMemo(() => {
    if (!rules.length) {
      return [true, false];
    }

    const [{ operator }] = rules;

    if (!every(rules, (rule) => operator === rule.operator)) {
      return [false, false];
    }

    const countries = rules.reduce(
      (result, { countries }) => result.concat(countries.split(',')),
      [] as string[]
    );
    const isRestricted = country && countries.includes(country);

    if ((operator === '!=' && isRestricted) || (operator === '=' && !isRestricted)) {
      return [false, true];
    }

    return [true, true];
  }, [country, rules]);
};

export default useGeoVisibility;
